import numeral from 'numeral';

require('numeral/locales.js');
numeral.locale('pt-br');

export const numeralMixin = {
    methods: {
        numeral (value) {
            return numeral(value);
        },

        formatNumber (value, format = '0,0') {
            let number = isNaN(parseFloat(value)) ? 0 : parseFloat(value);
            if (format === '0a' && number > 9999) {
                const lang = numeral.locale();
                numeral.locale('en');
                number = numeral(number).format('0a');
                numeral.locale(lang);
            }
            return numeral(number).format(format);
        },

        toNumber (value) {
            return numeral(value).value();
        }
    }
};



// WEBPACK FOOTER //
// ./src/modules/shared/mixins/numeral.mixin.js